import { typography, size, colors, mediaQueries } from '@everlywell/leaves';
import SectionWrapper from 'components/SectionWrapper';
import styled from 'styled-components';

import { SectionTitle as RawSectionTitle } from '../../Enterprise/SectionTitle';

export const SectionTitle = styled(RawSectionTitle)`
  text-align: center;
  margin-bottom: ${size.xs1}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.sm}px;
  }
`;

const Wrapper = styled(SectionWrapper)`
  background-color: ${colors.green1};
  margin-top: ${size.xl1}px;
`;

const Headline = styled.h2`
  ${typography.h2Text}
  margin-bottom: ${size.xl1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl4}px;
  }
`;

const InfoBlockContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
    justify-content: space-between;
    background-color: transparent;
  }
`;

export { Wrapper, Headline, InfoBlockContainer };
